/* import __COLOCATED_TEMPLATE__ from './created-at-cell.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type ContentWrapper from 'embercom/models/content-service/content-wrapper';

interface Args {
  contentWrapper: ContentWrapper;
}

export default class CreatedAtCell extends Component<Args> {
  @service declare appService: AppService;

  get createdAt(): Date {
    return this.args.contentWrapper.contents.firstObject?.contentData
      .most_recent_content_review_request_created_at;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ContentService::AiContentLibrary::List::Cells::CreatedAtCell': typeof CreatedAtCell;
  }
}
